"use strict";
const r = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
};
export {
  r as default
};
//# sourceMappingURL=index.es143.js.map
